/** @module csi/widget/CheckboxMenuItem */
define([
	"dojo/_base/declare",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/MenuItem",
	"dojo/text!./CheckboxMenuItem.html",

	"csi/widget/CheckBox"
], function(declare,_WidgetsInTemplateMixin,MenuItem,template) {

	return declare([MenuItem,_WidgetsInTemplateMixin], {
		templateString: template,
		checkboxNode: null,

		/**
		 * Checkbox is used in place of icon, so reset function to map iconClass to DOMNode
		 */
		_setIconClassAttr: null,

		/**
		 * Keep checkbox in sync with menu selection
		 * @param {boolean} selected
		 */
		_setSelected: function(selected) {
			this.checkboxNode.set("value", selected);
			this.inherited(arguments);
		}
	});
});
